import React from 'react';
import styled from '@benzinga/themetron';
import { showCornerStone } from '@benzinga/navigation-ui';
import { MoneyTemplateProps } from '../../entities';
import { MoneyPostLayout } from '../MoneyPostLayout';
const MoneyHeader = React.lazy(() => import('../MoneyHeader'));

export const CampaignTemplate: React.FC<MoneyTemplateProps> = ({ layoutHeader, post }) => {
  const pageType = post?.taxonomies?.find(object => object.taxonomy === 'page-type')?.term?.slug;
  const layout = showCornerStone(post ?? null) || pageType === 'full-width' ? 'wide' : 'narrow';

  if (!post) {
    return null;
  }

  return (
    <MoneyPostTemplateWrapper className={layout}>
      {layoutHeader ? layoutHeader : <MoneyHeader post={post} />}
      <MoneyPostLayout maxWidth={layout === 'wide' ? '1400px' : '1100px'} post={post} />
    </MoneyPostTemplateWrapper>
  );
};

const MoneyPostTemplateWrapper = styled.div`
  &.narrow {
    .header-container,
    .layout-container {
      max-width: 1100px;
    }
  }
  .main-content-container {
    padding-left: 0;
    padding-right: 0;
  }
  .layout-footer {
    .layout-container {
      max-width: 1100px;
    }
  }
  .money-page-main {
    /* display: flex; */
    position: relative;
    width: 100%;

    .money-post-wrapper {
      width: 100%;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &.section-title {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
  }

  .cornerstone-navigation {
    display: block;
    width: 100%;
    border: 1px solid #ceddf2;
    border-radius: 4px;
    padding: 0;
  }
`;
